import { useState } from "react";
import DeleteModal from "../../../../common/DeleteModal";
import VacationsService from "../../../../../services/HRM/VacationsService";

const CardItem = ({ item, index, setItem, setModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);

	return (
		<tr key={index} className="text-center">
			<td>
				<strong>{item?.employee?.id}</strong>
			</td>
			<td>{item?.employee?.name}</td>
			<td>{item?.employee?.department?.name || "-"}</td>
			<td>{item?.departureDay ? item.departureDay.split("T")[0] : "-"}</td>
			<td>{item?.returnDay ? item.returnDay.split("T")[0] : "-"}</td>
			<td>{item?.reason || "-"}</td>
			<td>{item?.type || "-"}</td>
			<td>{item?.numberOfDays ?? "-"}</td>
			<td>
				<div className="d-flex justify-content-center gap-2">
					<i
						className="la la-pencil cursor-pointer text-primary"
						style={{ fontSize: "1.4rem" }}
						onClick={() => {
							setItem(item);
							setModal(true);
						}}
					/>
					<i
						className="la la-trash cursor-pointer text-danger"
						style={{ fontSize: "1.4rem" }}
						onClick={() => setDeleteModal(true)}
					/>
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.employee?.name}
					deletedItem={item}
					modelService={new VacationsService()}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
